export const subHeaderText = {
    funding_options:
        "We've already taken your details from Funding Options so we just need you to fill in the gaps."
};
